import React from 'react';
import EmojiPicker, { EmojiClickData } from 'emoji-picker-react';
import { AdminChecklistPhaseDto } from '../../types';
import AdminModalShell from './AdminModalShell';

interface ChecklistPhaseIconModalProps {
    phase: AdminChecklistPhaseDto;
    onClose: () => void;
    onSave: (icon: string | null) => Promise<void>;
}

const ChecklistPhaseIconModal: React.FC<ChecklistPhaseIconModalProps> = ({ phase, onClose, onSave }) => {
    const [icon, setIcon] = React.useState(phase.icon ?? '');
    const [saving, setSaving] = React.useState(false);

    const handleEmojiClick = (emojiData: EmojiClickData) => {
        setIcon(emojiData.emoji);
    };

    const handleSave = async () => {
        setSaving(true);
        try {
            await onSave(icon.trim() || null);
            onClose();
        } finally {
            setSaving(false);
        }
    };

    return (
        <AdminModalShell title={`Phase icon: ${phase.name}`} onClose={onClose} size="md">
            <EmojiPicker onEmojiClick={handleEmojiClick} />
            <div className="mt-4 flex items-center gap-2">
                <span className="text-sm text-gray-600">Selected:</span>
                <span className="text-2xl">{icon || '—'}</span>
            </div>
            <div className="mt-6 flex justify-end gap-2">
                <button
                    type="button"
                    onClick={() => setIcon('')}
                    className="rounded-md bg-gray-200 px-4 py-2 text-gray-800 hover:bg-gray-300"
                >
                    Clear
                </button>
                <button
                    type="button"
                    onClick={handleSave}
                    disabled={saving}
                    className="rounded-md bg-green-600 px-4 py-2 text-white hover:bg-green-700 disabled:opacity-50"
                >
                    {saving ? 'Saving...' : 'Save'}
                </button>
            </div>
        </AdminModalShell>
    );
};

export default ChecklistPhaseIconModal;
